import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import CheckModal from './CheckModal';

const phoneNumber = '01012341234';
const point = 5000;

const DeliveryManWithdraw = () => {
  const [accountNum, setAccountNum] = useState<string>('');
  const [visibleNumber, setVisibleNumber] = useState<boolean>(false);

  const onChange_accountNum = (e: any) => {
    setAccountNum(e.target.value);
  };

  const openCheckAccount = () => {
    if (accountNum.length > 9) setVisibleNumber(true);
  };

  return (
    <>
      <Style>
        <div className="content">
          <img src={`${process.env.PUBLIC_URL}/img/knock_logo.png`} width="14%" alt="logo" />
          <h1>{'축하드려요 🎉\n출금 가능한 포인트를\n다 모았어요!'}</h1>

          <div>
            <h4>응원지원금 받을 계좌번호를 입력해주세요</h4>
            <input
              value={accountNum}
              onChange={onChange_accountNum}
              placeholder="-없이 숫자만 입력해주세요"
              maxLength={13}
            />
          </div>

          <div className="footer">
            <button className={`${accountNum.length < 10 && 'unabled'}`} onClick={openCheckAccount}>
              <h2>응원지원금 받기</h2>
            </button>
          </div>
        </div>
      </Style>
      <CheckModal
        isVisible={visibleNumber}
        setVisible={setVisibleNumber}
        type="account"
        number={accountNum}
      />
    </>
  );
};
export default DeliveryManWithdraw;

export const Style = styled.div`
  .content {
    position: relative;
    width: 100%;
    height: 100dvh;
    text-align: left;
    padding: 10px;
    background: #ffffff;
    white-space: pre-line;
  }
  img {
    padding-bottom: 10%;
  }
  h1 {
    font-size: 28px;
    line-height: 40px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    font-weight: 600;
    margin-bottom: 10%;
  }
  h4 {
    font-weight: 500;
    color: #555555;
  }
  input {
    margin: 10px 0;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #cecece;
    padding: 10px 12px;
    font-size: 16px;
    line-height: 22px;
    color: #555555;
    font-weight: 500;
  }
  input::placeholder {
    color: #cecece;
  }
  .footer {
    width: calc(100% - 20px);
    position: fixed;
    bottom: 10%;
  }
  button {
    margin-top: 12px;
    margin-bottom: 7vh;
    width: 100%;
    height: 7vh;
    background: #4dd2ae;
    border: none;
    border-radius: 5px;
    h2 {
      font-weight: 600;
      margin: 0;
      color: #ffffff;
    }
  }
  button.unabled {
    background: #cecece;
    border: 1px solid #cecece;
  }
`;
